import React from 'react';
import { NavLink } from 'react-router-dom';

class Faq extends React.Component {
    render() {
        return (
            <>
                <div className="section-full p-t80 p-b50 bg-white inner-page-padding">
                    <div className="container">
                        <div className="section-content">
                            <div className="row">
                                <div className="col-md-6 col-sm-6">
                                    {/* TITLE START */}
                                    <div className="section-head">
                                        <div className="mt-separator-outer separator-left">
                                            <div className="mt-separator">
                                                <h2 className="text-uppercase sep-line-one ">
                                                    <span className="font-weight-300 text-primary">Some</span> FAQ
                                                </h2>
                                            </div>
                                        </div>
                                    </div>
                                    {/* TITLE END */}
                                    <div className="section-content p-b30">
                                        <div className="mt-accordion acc-bg-gray" id="accordion5">
                                            <div className="panel mt-panel">
                                                <div className="acod-head acc-actives">
                                                    <h6 className="acod-title">
                                                        <a data-toggle="collapse" href="#collapseOne5" data-parent="#accordion5">
                                                            How long does the process take?
                                                            <span className="indicator"><i className="fa" /></span>
                                                        </a>
                                                    </h6>
                                                </div>
                                                <div id="collapseOne5" className="acod-body collapse in">
                                                    <div className="acod-content p-tb15">
                                                        Timelines vary by project, but from final measurements to installation, it typically takes 3–6 weeks.
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="panel mt-panel">
                                                <div className="acod-head">
                                                    <h6 className="acod-title">
                                                        <a data-toggle="collapse" href="#collapseTwo5" className="collapsed" data-parent="#accordion5">
                                                            Do you offer free consultations?
                                                            <span className="indicator"><i className="fa" /></span>
                                                        </a>
                                                    </h6>
                                                </div>
                                                <div id="collapseTwo5" className="acod-body collapse">
                                                    <div className="acod-content p-tb15">
                                                        Again, we also offer free home
                                                        visit consultation and we want
                                                        the clients/potential clients to be
                                                        aware of this
                                                        .
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="panel mt-panel">
                                                <div className="acod-head">
                                                    <h6 className="acod-title">
                                                        <a data-toggle="collapse" href="#collapseTwo5" className="collapsed" data-parent="#accordion5">
                                                            Do you work with specific budgets?
                                                            <span className="indicator"><i className="fa" /></span>
                                                        </a>
                                                    </h6>
                                                </div>
                                                <div id="collapseTwo5" className="acod-body collapse">
                                                    <div className="acod-content p-tb15">
                                                        Absolutely. We tailor designs based on your budget without compromising on quality.
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="panel mt-panel">
                                                <div className="acod-head">
                                                    <h6 className="acod-title">
                                                        <a data-toggle="collapse" href="#collapseThree5" className="collapsed" data-parent="#accordion5">
                                                            Can I see past projects before deciding?
                                                            <span className="indicator"><i className="fa" /></span>
                                                        </a>
                                                    </h6>
                                                </div>
                                                <div id="collapseThree5" className="acod-body collapse">
                                                    <div className="acod-content p-tb15">
                                                        Of course. We can connect you with previous clients or arrange visits to nearby installations.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* CALL TO ACTION SECTION */}
                                <div className="col-md-6 col-sm-6">
                                    <div className="section-head">
                                        <div className="mt-separator-outer separator-left">
                                            <div className="mt-separator">
                                                <h2 className="text-uppercase sep-line-one">
                                                    <span className="font-weight-300 text-primary"></span>Call to Action
                                                </h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-icon-box-wraper p-a25 m-b30 onhover-box-shadow bg-gray center">
                                        <div className="mt-icon-box-sm inline-icon text-primary m-b20 radius bg-secondry scale-in-center">
                                            <span className="icon-cell text-primary"><i className="flaticon-sketch" /></span>
                                        </div>
                                        <div className="icon-content text-black">
                                            <h4 className="mt-tilte text-uppercase font-weight-600 m-b20">Ready to Transform?</h4>
                                            <p>
                                                Let’s turn your vision into a space you’ll love living in.
                                                Contact us today to schedule your consultation or ask a question—we’re happy to help.
                                            </p>
                                            <NavLink to="/contactus" className="site-button-link" data-hover="Contact Us" style={{border:"2px solid #e8ba74", padding:"10px 20px", borderRadius:"5px",fontSize:"16px"}}>
                                                Contact Us <i className="fa fa-angle-right arrow-animation" />
                                            </NavLink>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Faq;
